export default __webpack_public_path__ + "static/media/ritual-image-1579909053449.888af679.jpeg";